(() => {
  if (window.RadaStockStatus) return;
  function refresh(section) {
    const panel = section.querySelector('[data-rada-stock]');
    const status = panel?.querySelector('.rada-stock-status');
    const input = section.querySelector('product-form form[action*="/cart/add"] [name="id"]');
    if (!status || !input) return;
    const variants = JSON.parse(panel.querySelector('[data-rada-stock-variants]').textContent);
    const variant = variants.find(item => String(item.id) === input.value);
    if (!variant) return;
    const quantity = Math.max(1, Number(section.querySelector('input[name="quantity"]')?.value || 1));
    const state = variant.tracked && variant.quantity >= quantity ? 'inStock' : variant.available ? 'order' : 'unavailable';
    const text = status.dataset[state];
    if (status.textContent !== text) status.textContent = text;
    status.dataset.state = state;
    for (const button of section.querySelectorAll('product-form button[name="add"]')) {
      const label = button.querySelector(':scope > span');
      if (!label || state === 'unavailable') continue;
      const caption = window.variantStrings?.addToCart || 'Add to cart';
      if (label.textContent.trim() !== caption) label.textContent = caption;
      button.dataset.inventoryQuantity = String(variant.tracked ? variant.quantity : 0);
    }
  }
  let scheduled = false;
  function refreshAll() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll('section[id^="MainProduct-"]').forEach(refresh);
    });
  }
  window.RadaStockStatus = { refresh: refreshAll };
  document.addEventListener('change', refreshAll);
  document.addEventListener('input', refreshAll);
  document.addEventListener('shopify:section:load', refreshAll);
  const observer = new MutationObserver(refreshAll);
  observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['value'] });
  refreshAll();
})();
